import { MODEL } from "../../model";

const Header = () => {
  return (
    <header className=" [ heroSection ] ">
      
      {/* Tag line */}
      <div className=" [ hero__content ] ">
        <h1 className=" [ hero__title ] ">
          <span>Knowledge is cultivated through effort</span>
          <span> Neglect lets ignorance grow</span>
        </h1>
      </div>
      
      {/* Hero Image section */}
      <div
        id="carouselExampleIndicators"
        className=" [ carousel slide ] "
        data-bs-ride="true"
      >
        <div className="carousel-indicators">
          {MODEL.data.banners &&
            MODEL.data.banners.map((v) => {
              if (v.id === 0) {
                return (
                  <button
                    type="button"
                    data-bs-target="#carouselExampleIndicators"
                    data-bs-slide-to={v.id}
                    className=" [ active ] "
                    aria-current="true"
                    aria-label={v.title}
                    key={v.id}
                  ></button>
                );
              } else {
                return (
                  <button
                    type="button"
                    data-bs-target="#carouselExampleIndicators"
                    data-bs-slide-to={v.id}
                    aria-current="true"
                    aria-label={v.title}
                    key={v.id}
                  ></button>
                );
              }
            })}
        </div>
        <div className=" [ carousel-inner ] ">
          {MODEL.data.banners &&
            MODEL.data.banners.map((v) => {
              return (
                <div
                  className={`carousel-item ${
                    v.id === 0 ? "active" : ""
                  } c-image`}
                  key={v.id}
                >
                  <img
                    width={480}
                    height={100}
                    loading="lazy"
                    src={`/${v.images.fallback.src}`}
                    sizes="(max-width: 600px) 480px, 
         (max-width: 1200px) 800px, 
         1200px"
                    className="block w-full aspect-[1/1] h-auto"
                    alt={v.images.fallback.alt}
                    title={v.images.fallback.alt}
                  />
                </div>
              );
            })}
        </div>
        <button
          className=" [ carousel-control-prev ] "
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide="prev"
        >
          <span
            className=" [ carousel-control-prev-icon ] "
            aria-hidden="true"
          ></span>
          <span className=" [ visually-hidden ] ">Previous</span>
        </button>
        <button
          className=" [ carousel-control-next ] "
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide="next"
        >
          <span
            className=" [ carousel-control-next-icon ] "
            aria-hidden="true"
          ></span>
          <span className=" [ visually-hidden ] ">Next</span>
        </button>
      </div>
      {/* space */}
      <br />
      <br />
    </header>
  );
};

export default Header;
